import { render } from "./AppointmentProducts.vue?vue&type=template&id=65d220d3&scoped=true"
import script from "./AppointmentProducts.vue?vue&type=script&lang=js"
export * from "./AppointmentProducts.vue?vue&type=script&lang=js"

import "./AppointmentProducts.vue?vue&type=style&index=0&id=65d220d3&scoped=true&lang=css"
import "./AppointmentProducts.vue?vue&type=style&index=1&id=65d220d3&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d220d3"]])

export default __exports__